import { BaseModel } from './BaseModel';

export class ModpackBuildLogs extends BaseModel {
    public status = '';
    public serverPack = false;
    public validatedAt: string | null = null;
    public error: string | null = null;
    public logs = '';
}
